import React from 'react';
import { connect } from "react-redux";
import { IContent, IProduct } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './DoublePushBlock.scss';

import Title from '../../Elements/Title/TitleElement';
import PushElement from '../../Elements/Push/PushElement';

interface IDoublePushBlockProps {
  context?: IContent;
  products: IProduct[];
}

const DoublePushBlock = ({ context, products }: IDoublePushBlockProps) => {
  const isUPC = process.env.REACT_APP_ENV === "upc";

  let content = context.double_push_web;
  if (isUPC) {
    content = context.double_push_upc;
  }
  const { is_active, items, title } = content;

  const listFreeToPlay = items.map((item: any, index: number) => {
    let detailedProduct = null;
    if (products && item.product && item.product.product_id && item.product.product_type) {
      const productFound = products.filter((productFromList: IProduct) => productFromList.id === item.product.product_id);
      detailedProduct = productFound.length === 1 ? productFound[0] : null;
    }
    return (
      <PushElement
        key={index}
        info={item}
        index={index}
        product={detailedProduct}
      />
    );
  });

  return is_active && items.length > 0 && (
    <div className="block-double_push">
      {title && (
        <Title>{title}</Title>
      )}
      <div className="items">
        {listFreeToPlay}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products.data
});

export default connect(mapStateToProps)(withContent(DoublePushBlock));
